<template>
  <button
    @click="toggleTheme"
    class="theme-toggle-btn"
    :class="{ 'navbar-style': isNavbar }"
    :title="isDarkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
  >
    <!-- Icono de sol (modo claro) -->
    <svg
      v-if="!isDarkMode"
      xmlns="http://www.w3.org/2000/svg"
      class="theme-icon"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
      />
    </svg>
    <!-- Icono de luna (modo oscuro) -->
    <svg
      v-else
      xmlns="http://www.w3.org/2000/svg"
      class="theme-icon"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
      />
    </svg>
  </button>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ThemeToggle',
  computed: {
    ...mapGetters(['isDarkMode'])
  },
  methods: {
    ...mapActions(['toggleTheme'])
  },
  props: {
    isNavbar: Boolean,
  }
};
</script>

<style scoped>
.theme-toggle-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.theme-toggle-btn:hover {
  background: rgba(0, 0, 0, 0.1);
}

.dark .theme-toggle-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.theme-icon {
  width: 24px;
  height: 24px;
  color: #333;
  transition: transform 0.3s ease;
}

.dark .theme-icon {
  color: #fbbf24;
}

.theme-toggle-btn:hover .theme-icon {
  transform: rotate(20deg);
}
/* Color por defecto para cuando está en el Navbar */
.navbar-style .theme-icon {
  color: #fff !important;
}

.navbar-style:hover {
  background: rgba(0, 0, 0, 0.05);
}

.dark .navbar-style .theme-icon {
  color: #fbbf24 !important;
}
</style>
